import { action } from 'app/actions';

export const GET_ES_FILTER_TRI = 'ES-TRI/getESFilterTRI';
export const GET_ES_TRI_DETAIL = 'ES-TRI/getESTRIDetail';
export const GET_ES_REPORT_TRI = 'ES-TRI/getESReportTRI';
export const GENERATE_REPORT_TRI = 'ES-TRI/generateReportTRI';
export const GET_ES_QUESTION_DETAIL_TRI = 'ES-TRI/getQuestionsDetailTRI';

export const GET_ES_TRI_STUDENT_DETAIL = 'ES-TRI/getESTRIStudentDetail';
export const GET_ES_STUDENT_REPORT_TRI = 'ES-TRI/getESStudentReportTRI';
export const GET_ES_EVALUATIONS_CICLE_STUDENT_TRI = 'ES-TRI/getESEvaluationsCicleStudentTRI';
export const GET_ES_TRI_SCHOOL_DETAIL = 'ES-TRI/getESTRISchoolDetail';

export const GET_ES_SCHOOL_REPORT_TRI = 'ES-TRI/getESSchoolReportTRI';
export const GENERATE_SCHOOL_REPORT_TRI = 'ES-TRI/generateSchoolReportTRI';
export const GET_ES_APPLICATION_REPORT_TRI = 'ES-TRI/getESApplicationReportTRI';
export const GET_ES_TRI_APPLICATION_DETAIL = 'ES_TRI/getESTRIApplicationDetail';

export const getESFilterTRI = (payload) => action(GET_ES_FILTER_TRI, { payload });
export const getESTRIDetail = (payload) => action(GET_ES_TRI_DETAIL, { payload });
export const getESReportTRI = (payload) => action(GET_ES_REPORT_TRI, { payload });
export const generateReportTRI = (payload) => action(GENERATE_REPORT_TRI, { payload });
export const getQuestionsDetailTRI = (payload) => action(GET_ES_QUESTION_DETAIL_TRI, { payload });

export const getESTRIStudentDetail = (payload) => action(GET_ES_TRI_STUDENT_DETAIL, { payload });
export const getESStudentReportTRI = (payload) => action(GET_ES_STUDENT_REPORT_TRI, { payload });
export const getESEvaluationsCicleStudentTRI = (payload) =>
  action(GET_ES_EVALUATIONS_CICLE_STUDENT_TRI, { payload });

export const getESSchoolReportTRI = (payload) => action(GET_ES_SCHOOL_REPORT_TRI, { payload });
export const generateSchoolReportTRI = (payload) => action(GENERATE_SCHOOL_REPORT_TRI, { payload });
export const getESTRISchoolDetail = (payload) => action(GET_ES_TRI_SCHOOL_DETAIL, { payload });
export const getESApplicationReportTRI = (payload) =>
  action(GET_ES_APPLICATION_REPORT_TRI, { payload });
export const getESTRIApplicationDetail = (payload) =>
  action(GET_ES_TRI_APPLICATION_DETAIL, { payload });
